import { render } from "./Footer.vue?vue&type=template&id=16c079e2&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=ts"
export * from "./Footer.vue?vue&type=script&lang=ts"

import "./Footer.vue?vue&type=style&index=0&id=16c079e2&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-16c079e2"

export default script